import { requestGet, requestPost } from '@/common/request';

export default {
  // 数据范围筛选框
  async queryDataScopeByErp(query) {
    return await requestPost('/generic/skuPoolService/queryDataScopeByErp', query);
  },
  // 正在进行中的活动&日历
  async queryCalendarDataByErp(query) {
    return await requestPost('/generic/skuPoolService/queryCalendarDataByErp', query);
  },
  // 会场明细
  async getActivityDetailData(query) {
    return await requestPost('/generic/skuPoolService/getActivityDetailData', query);
  },
  // 商品明细
  async getSkuDetailData(query) {
    return await requestPost('/generic/skuPoolService/getSkuDetailData', query);
  },
  //平台.店铺.品类.品牌筛选框
  async queryBrandAndShopList(query) {
    return await requestPost('/generic/skuPoolService/queryBrandAndShopList', query);
  },
  // 活动详情列表(table页)
  async queryPlanInfoList(query) {
    return await requestPost('/generic/skuPoolService/queryPlanInfoList', query);
  },
  // 活动期漏斗图指标
  async queryIndexOngoingInfo(query) {
    return await requestPost('/generic/skuPoolService/queryIndexOngoingInfo', query);
  },
  //趋势分析
  async getActivityTrendDetailData(query) {
    return await requestPost('/generic/skuPoolService/getActivityTrendDetailData', query);
  },

  //排行榜
  async queryTopRankInfo(query) {
    return await requestPost('/generic/skuPoolService/queryTopRankInfo', query);
  },
  //我的商品->活动分析->会场分析→筛选框
  async queryActivityScopeList(query) {
    return await requestPost('/generic/skuPoolService/queryActivityScopeList', query);
  },
  //我的商品->活动分析->会场分析→楼层数据信息(查询及下载)
  async queryFloorList(query) {
    return await requestPost('/generic/skuPoolService/queryFloorList', query);
  },

  //我的商品->活动分析->用户分析→用户基础属性
  async queryBaseInfoList(query) {
    return await requestPost('/generic/skuPoolService/queryBaseInfoList', query);
  },

  //我的商品->活动分析->用户分析→用户购物属性
  async queryShoppingInfoList(query) {
    return await requestPost('/generic/skuPoolService/queryShoppingInfoList', query);
  },

  //我的商品->活动分析->用户分析→用户增长属性
  async queryUGInfoList(query) {
    return await requestPost('/generic/skuPoolService/queryUGInfoList', query);
  },

  //我参与的->首页->实时概览趋势图
  async globalEffectRealIndexAndTrend(query) {
    return await requestPost('/generic/skuPoolService/globalEffectRealIndexAndTrend', query);
  },
  //我参与的->首页->频道tab正在参与的频道
  async queryParticipantChannelInfo(query) {
    return await requestPost('/generic/skuPoolService/queryParticipantChannelInfo', query);
  },

  //我参与的->首页->实时数据监控
  async queryRTChannelInfo(query) {
    return await requestPost('/generic/skuPoolService/queryRTChannelInfo', query);
  },

  //我参与的->首页->频道->历史成交趋势
  async channelEffectTrend(query) {
    return await requestPost('/generic/skuPoolService/channelEffectTrend', query);
  },

  //我参与的->秒杀详情页->指标卡&趋势图
  async channelEffectIndexAndTrend(query) {
    return await requestPost('/generic/skuPoolService/channelEffectIndexAndTrend', query);
  },
  //我参与的->秒杀详情页->列表
  async channelEffectDetailList(query) {
    return await requestPost('/generic/skuPoolService/channelEffectDetailList', query);
  },
  //我参与的->场域分析->搜索->核心指标卡&漏斗图&趋势图&明细表格查询
  async platDataOneServiceQuery(query) {
    return await requestPost('/generic/platDataOneService/query', query);
  },
  //我参与的->场域分析->搜索->明细表格下载
  async platDataOneServiceDownloadFile(query) {
    return await requestPost('/generic/platDataDownLoadService/downloadFile', query);
  },
  // 新版2022-11-24保存指标配置
  async saveGoodsAnalysisIndexInfo(query) {
    return await requestPost('/generic/participantService/saveGoodsAnalysisIndexInfo', query);
  },
  // 查询保存的指标
  async queryGoodsAnalysisIndexInfo(query) {
    return await requestPost('/generic/participantService/queryGoodsAnalysisIndexInfo', query);
  },
  // 新版趋势图 23-03016 MVP替换为新接口
  async participantServiceQueryHomeIndex(query) {
    return await requestPost('/generic/salerPositionService/queryCommodityOverView', query);
  },
  //关注取消关注
  async goodsAnalysisItemFollow(query) {
    return await requestPost('/generic/participantService/goodsAnalysisItemFollow', query);
  },
  //新版商品分析-表格详情 2023-03-16 MVP替换为新接口
  async queryGoodsAnalysis(query) {
    return await requestPost('/generic/salerPositionService/queryCommodityTable', query);
  },
  // 新版2022-11-24平台.店铺.品类.品牌筛选框
  async queryGeneralBrandAndShopList(query) {
    return await requestPost('/generic/skuPoolService/queryGeneralBrandAndShopList', query);
  },
  // 新版2022-11-24新数据筛选框
  async queryGeneralDataScopeByErp(query) {
    return await requestPost('/generic/skuPoolService/queryGeneralDataScopeByErp', query);
  },

  // 2023-03-13 mvp 销售计划详情
  async queryMarketingPlanSummary(query) {
    return await requestGet('/marketingPlan/summary', query);
  },
  // 2023-03-13 mvp 商品分组
  async queryGoodsGroupList(query) {
    return await requestGet('/goodsGroup/list', query);
  },
  // 2023-03-13 mvp 销售计划列表
  async queryMarketingPlanList(query) {
    return await requestGet('/marketingPlan/list', query);
  },
  // 2023-03-28 查询sku在大盘中的排名信息
  async querySkuDiagnoseInfo(query) {
    return await requestPost('/generic/salerPositionService/querySkuDiagnoseInfo', query);
  },
  // 2023-03-28 查询sku渠道级联信息
  async queryLastChannelInfo(query) {
    return await requestPost('/generic/salerPositionService/queryLastChannelInfo', query);
  },
  // 2023-03-28 查询sku渠道诊断列表
  async queryDiagnoseTotalList(query) {
    return await requestPost('/generic/salerPositionService/queryDiagnoseTotalList', query);
  },
  // 2023-03-28 下载sku诊断信息
  async downloadDiagnoseInfos(query) {
    return await requestPost('/generic/salerPositionService/downloadDiagnoseInfos', query);
  },
  // 2023-04-13 mvp 销售计划首页概览置顶保存
  async saveMarketingPlan(query) {
    return await requestGet('/marketingPlan/placementSave', query);
  },
};
